
import FileInput from "../../../common/input/FileInput";

export default function FieldImage({ existingPreviewUrl, onChange }) {
	return (
		<FileInput
			onChange={onChange}
			label="عکس وبینار"
			existingPreviewUrl={existingPreviewUrl}
		/>
	);
}
